import { createSlice } from "@reduxjs/toolkit";

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState: {
    warehouse: {},
  },

  reducers: {
    setWarehouse: (state, action) => {
      state.warehouse = action.payload;
    },
    dropWarehouse: (state) => {
      state.warehouse = {};
    },
  },
});


export default warehouseSlice.reducer;
export const { setWarehouse, dropWarehouse } = warehouseSlice.actions;
